module.exports = __webpack_public_path__ + "static/media/icon-font.485587b8.woff2";